import React from 'react';
import styled, { css } from 'styled-components';
import { ToggleSwitch } from '@lt/components';
import { i18n, useTranslation } from '@lt/localization';
import { getActiveLabelForCancellationPolicy } from './utils';
import Icon from '../../../Icon';

import { FilterPropTypes, FilterDefaultProps } from '../../proptypes';
import {
  isToggleFilterSelected,
  isToggleFilterDisabled,
} from '../../../../utils/filtersUtils';
import ToggleFilterGroup from '../ToggleFilterGroup';

const FilterCancellationPolicy = ({
  data,
  className,
  onChange,
  onClear,
  isMobile,
  currencyCode,
  isHotelOnly,
}) => {
  const { t } = useTranslation();

  const tourType = isHotelOnly
    ? t('tourType.onlyHotel.plural')
    : t('tourType.withFlights.plural');

  const LABEL_OFF = t('filters.cancellation.label_off', {
    title: tourType,
  });

  return (
    <StyledFilter
      className={className}
      data={data}
      Filter={FilterCancellationPolicy}
      labelOn={getActiveLabelForCancellationPolicy(isHotelOnly)}
      labelOff={LABEL_OFF}
      switcherIcon={isMobile ? null : <StyledCancellationIcon />}
      labelIcon={<StyledLabelIcon />}
      onChange={onChange}
      onClear={onClear}
      isMobile={isMobile}
      currencyCode={currencyCode}
      // styled props
      active={isToggleFilterSelected(data)}
      disabled={isToggleFilterDisabled(data)}
    />
  );
};

const StyledCancellationIcon = styled(Icon).attrs({
  type: 'free-cancellation-colored',
  width: 16,
  height: 20,
})``;

const StyledFilter = styled(ToggleFilterGroup)`
  ${ToggleSwitch.PinComponent} {
    ${({ active }) =>
      active &&
      css`
        background: linear-gradient(to bottom, #2ea0d9, #1be31b);
        box-shadow: 0 0 20px 0 rgba(37, 192, 127, 0.5);
      `}
  }

  ${StyledCancellationIcon} {
    path {
      fill: none;
      stroke: ${({ theme }) => theme.colors[ToggleSwitch.COLORS.NORMAL]};
      stroke-width: 1;

      ${({ disabled }) =>
        disabled &&
        css`
          fill: none;
          stroke: ${({ theme }) => theme.colors[ToggleSwitch.COLORS.DISABLED]};
        `}

      ${({ active, theme }) =>
        active &&
        css`
          fill: ${theme.colors.white};
          stroke: none;

          &:last-child {
            stroke: #28c18b;
            stroke-width: 2;
          }
        `}
    }
  }
`;

const StyledLabelIcon = styled(Icon).attrs({
  type: 'free-cancellation-colored',
  width: 16,
})`
  position: absolute;
  margin-left: 5px;
  stroke: ${({ theme }) => theme.colors.white};
  stroke-width: 1px;

  svg {
    height: 21px;
  }
`;

FilterCancellationPolicy.filterName = 'free_cancel';
FilterCancellationPolicy.filterLabel = i18n.t('filters.cancellation.title');
FilterCancellationPolicy.valuesLabel = (data, isHotelOnly) =>
  data.find((item) => item.id === true && item.selected) &&
  getActiveLabelForCancellationPolicy(isHotelOnly);

FilterCancellationPolicy.propTypes = FilterPropTypes;
FilterCancellationPolicy.defaultProps = FilterDefaultProps;

export { FilterCancellationPolicy };
